import {faSquare as faSquareRegular} from '@fortawesome/pro-regular-svg-icons';
import {faBoltLightning, faSquare} from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

import {Text} from '../Text';

import {Icon} from './Icon';

import type {Category} from '../../types';
import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';

type Props = Omit<FontAwesomeIconProps, 'icon'> & {
  category: Pick<Category, 'colour' | 'isArchived' | 'model'>;
  shouldShowAiIcon?: boolean;
  isHollow?: boolean;
  children?: React.ReactNode;
};

export function CategoryIcon(props: Props): React.JSX.Element {
  const {
    category,
    shouldShowAiIcon,
    isHollow,
    children,
    className,
    ...restProps
  } = props;
  const hasChildren = !!children;

  return (
    <Text
      as={category.isArchived ? 'invalid' : 'body'}
      tag="span"
      className={className}
      title={
        category.isArchived ? 'This category has been deleted.' : undefined
      }
    >
      <Icon
        {...restProps}
        icon={isHollow ? faSquareRegular : faSquare}
        style={{color: category.colour}}
        className={clsx((hasChildren || shouldShowAiIcon) && 'mr-1')}
      />

      {category.model && shouldShowAiIcon && (
        <Icon
          {...restProps}
          icon={faBoltLightning}
          className={clsx('text-blue11', hasChildren && 'mr-1')}
        />
      )}

      {children}
    </Text>
  );
}

CategoryIcon.displayName = 'CategoryIcon';
